const LoginBackground = () => {
    return (
        <div className="loginBackground"></div>
    )
}

export default LoginBackground;